// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ZqSg","header":"ReportDetails_header__3Wyks","title":"ReportDetails_title__1V2jN","left":"ReportDetails_left__1L8tZ"};